import {
  getAuth,
  signInWithPopup,
  FacebookAuthProvider,
  signOut,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import { OAuthProvider } from "firebase/auth";
import { firebaseLogin } from "redux/slice/session/auth.slice";

import {
  liveStr,
} from "./utiles";
import { toast } from "react-toastify";
import axios from "axios";


const firebaseConfig = {
  apiKey: "AIzaSyAR-RtulWXO1DB1KFthxDvoPdUdKlzaOKo",
  // authDomain:"affirmate-f8861.firebaseapp.com",
  authDomain: "auth.affirmate.app", //"affirmate-f8861.firebaseapp.com",
  databaseURL: "https://affirmate-f8861-default-rtdb.firebaseio.com",
  projectId: "affirmate-f8861",
  storageBucket: "affirmate-f8861.appspot.com",
  messagingSenderId: "362515734491",
  appId: "1:362515734491:web:bb0e40fd8001f2ef6791fe",
  measurementId: "G-3FLEDW0R5E",
};

export const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const facebook = new FacebookAuthProvider();
const ap = getAuth();

export const signInWithFaceBook = (
  dispatch,
  navigate,
  { status },
  getCookieData,
  uT,
  typeScreen
) => {

  signInWithPopup(ap, facebook)
    .then((result) => {

      const user = result.user;
      console.log('user', user);
      console.log('Wy', user?.Wy);
      console.log('user.uid', user.uid);
      console.log('user.uid', user?.uid == "74A5FzyIwfZ8JS915vqTxy7ggZ02" ? 'hfmjazwsak_1730456766@tfbnw.net' : user.email,);

      if (user) {
        const dataLogin = {
          email: user?.uid == "74A5FzyIwfZ8JS915vqTxy7ggZ02" ? 'hfmjazwsak_1730456766@tfbnw.net' : user.email,
          name: user.displayName,
          login_by: "4",
          profile_pic: user?.photoURL,
          user_platform_status: uT

        };
        dispatch(firebaseLogin(dataLogin))
          .unwrap()
          .then((res) => {
            sessionStorage.setItem("token", res?.data?.token);
            sessionStorage.setItem("success", res.success);


            if (res?.data?.is_register === '1') {
              if (uT == 2) {

                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-influencer-success`)

                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    // if (res?.data?.trial_completed === 1) {
                    //   navigate('/trial-influencer-success')
                    // } else 
                    if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires.",
                      {}
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              }
              else if (uT == 1) {
                if (status === 1) {
                  if (res?.data?.trial_updated === '1') {
                    navigate(`/trial-success`)
                    sessionStorage.setItem("token", res?.data?.token);
                    sessionStorage.setItem("success", res.success);

                  } else if (res?.data?.trial_updated === '0') {
                    if (res?.data?.payment_status === 1) {

                      if (res?.data?.trial_completed === 2) {
                        window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                      }
                    } else if (res?.data?.payment_status === 2) {
                      toast(
                        "You have an active subscription, please come back after your subscription expires."
                      );
                    } else if (res?.data?.payment_status === 3) {
                      toast(
                        "Please wait till your subscripition's expiry date to purchase the subscription"
                      );
                    }
                  }

                } else if (status === 0) {
                  navigate(`/redeem-gift`);
                  toast.success(res?.message);
                }

              }
            } else if (res?.data?.is_register === '0') {
              if (status === 1) {
                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-success`)
                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    toast.success(res?.message);

                    if (res?.data?.trial_completed === 1) {
                      navigate('/trial-success')

                      sessionStorage.setItem("token", res?.data?.token);
                      sessionStorage.setItem("success", res.success);
                    } else if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires."
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              } else if (status === 0) {
                navigate(`/redeem-gift`);
                toast.success(res?.message);
              }
            }
          });
      }
    })
    .catch((error) => {
      console.error("Error_facbook:->", error.message);
    });

  // signInWithRedirect(ap, facebook);
};

export const signInWithApple = (
  dispatch,
  navigate,
  { status },
  getCookieData,
  uT,
  typeScreen,
) => {

  console.log('typeScreen', typeScreen);

  const provider = new OAuthProvider("apple.com");

  signInWithPopup(ap, provider)
    .then((result) => {
      var credential = result.credential;

      var user = result.user;
      if (user) {
        const dataLogin = {
          email: user.email,
          name: user.displayName,
          login_by: "3",
          apple_id: result._tokenResponse.federatedId.split("/")[1],
          profile_pic: user?.photoURL,
          type: "1",
          user_platform_status: uT,
          registered_from: typeScreen.typeScreen ? 1 : 2
        };

        dispatch(firebaseLogin(dataLogin))
          .unwrap()
          .then((res) => {
            sessionStorage.setItem("token", res?.data?.token);
            sessionStorage.setItem("success", res.success);

            if (res?.data?.is_register === '1') {
              if (uT == 2) {

                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-influencer-success`)

                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    // if (res?.data?.trial_completed === 1) {
                    //   navigate('/trial-influencer-success')
                    // } else 
                    if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires.",
                      {}
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              }
              else if (uT == 1) {
                if (status === 1) {
                  if (res?.data?.trial_updated === '1') {
                    navigate(`/trial-success`)
                    sessionStorage.setItem("token", res?.data?.token);
                    sessionStorage.setItem("success", res.success);

                  } else if (res?.data?.trial_updated === '0') {
                    if (res?.data?.payment_status === 1) {

                      if (res?.data?.trial_completed === 2) {
                        window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                      }
                    } else if (res?.data?.payment_status === 2) {
                      toast(
                        "You have an active subscription, please come back after your subscription expires."
                      );
                    } else if (res?.data?.payment_status === 3) {
                      toast(
                        "Please wait till your subscripition's expiry date to purchase the subscription"
                      );
                    }
                  }

                } else if (status === 0) {
                  navigate(`/redeem-gift`);
                  toast.success(res?.message);
                }

              }
            } else if (res?.data?.is_register === '0') {
              if (status === 1) {
                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-success`)
                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    toast.success(res?.message);

                    if (res?.data?.trial_completed === 1) {
                      navigate('/trial-success')

                      sessionStorage.setItem("token", res?.data?.token);
                      sessionStorage.setItem("success", res.success);
                    } else if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires."
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              } else if (status === 0) {
                navigate(`/redeem-gift`);
                toast.success(res?.message);
              }
            }
          });
      }
    })
    .catch((error) => {
      console.log("err", error);
    });
};

export const googleSingOut = () => {
  signOut(auth)
    .then(() => {
      console.log("User signed out successfully");
    })
    .catch((error) => {
      console.error("Error signing out:", error);
    });
  console.log("Sign out initiated");
};


export const googleLogin = (dispatch,
  navigate,
  { status },
  getCookieData,
  codeResponse,
  uT,
  typeScreen
) => {

  console.log('status', typeScreen);

  if (codeResponse) {
    axios
      .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`, {
        headers: {
          Authorization: `Bearer ${codeResponse.access_token}`,
          Accept: 'application/json'
        }
      })
      .then((res) => {

        const dataLogin = {
          email: res?.data.email,
          name: res?.data.given_name,
          login_by: "2",
          profile_pic: res?.data?.photoURL,
          type: "1",
          user_platform_status: uT,
          registered_from: typeScreen.typeScreen ? 1 : 2

        };

        dispatch(firebaseLogin(dataLogin))
          .unwrap()
          .then((res) => {

            console.log('res_google', res);


            sessionStorage.setItem("success", res.success);
            sessionStorage.setItem("token", res?.data?.token);


            if (res?.data?.is_register === '1') {
              if (uT == 2) {

                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-influencer-success`)

                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    // if (res?.data?.trial_completed === 1) {
                    //   navigate('/trial-influencer-success')
                    // } else 
                    if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires.",
                      {}
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              }
              else if (uT == 1) {
                if (status === 1) {
                  if (res?.data?.trial_updated === '1') {
                    navigate(`/trial-success`)
                    sessionStorage.setItem("token", res?.data?.token);
                    sessionStorage.setItem("success", res.success);

                  } else if (res?.data?.trial_updated === '0') {
                    if (res?.data?.payment_status === 1) {

                      if (res?.data?.trial_completed === 2) {
                        window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                      }
                    } else if (res?.data?.payment_status === 2) {
                      toast(
                        "You have an active subscription, please come back after your subscription expires."
                      );
                    } else if (res?.data?.payment_status === 3) {
                      toast(
                        "Please wait till your subscripition's expiry date to purchase the subscription"
                      );
                    }
                  }

                } else if (status === 0) {
                  navigate(`/redeem-gift`);
                  toast.success(res?.message);
                }

              }
            } else if (res?.data?.is_register === '0') {
              if (status === 1) {
                if (res?.data?.trial_updated === '1') {
                  navigate(`/trial-success`)
                } else if (res?.data?.trial_updated === '0') {
                  if (res?.data?.payment_status === 1) {
                    toast.success(res?.message);

                    if (res?.data?.trial_completed === 1) {
                      navigate('/trial-success')

                      sessionStorage.setItem("token", res?.data?.token);
                      sessionStorage.setItem("success", res.success);
                    } else if (res?.data?.trial_completed === 2) {
                      window.location.href = `${liveStr}?client_reference_id=${getCookieData}`;
                    }
                  } else if (res?.data?.payment_status === 2) {
                    toast(
                      "You have an active subscription, please come back after your subscription expires."
                    );
                  } else if (res?.data?.payment_status === 3) {
                    toast(
                      "Please wait till your subscripition's expiry date to purchase the subscription"
                    );
                  }
                }
              } else if (status === 0) {
                navigate(`/redeem-gift`);
                toast.success(res?.message);
              }
            }
          });
      }).catch((err) => console.log(err));
  }
}